import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Grid, Card, CardContent, CardHeader,
  Divider, Typography, Tooltip } from '@material-ui/core';
import { getWeatherIcon } from '../assets/weather/weather';
import rainIcon from '../assets/weather/rain.png';
import windIcon from '../assets/weather/wind.png';

const styles = {
  card: {
    minWidth: 280,
    //height: 240,
  },
  cardContent: {
    padding: 4,
    paddingTop: 6,
  },
};

class WeatherWidget extends Component {
  state = {
    location: ''
  };

  componentDidMount() {
    const { fetchingOrganizationsStatus, organizationsList, getOrganizations, fetchingWeatherStatus, getTodaysWeather } = this.props;

    //If Organizations are loaded, set location and get Forecast. Retrieve Organization information if none exist 
    if (fetchingOrganizationsStatus === 'Loaded') {
      if (organizationsList.length > 0) {
        this.setState({ location: (organizationsList[0].city+', '+organizationsList[0].region) });
        //Retrieve Today's weather if it hasn't been loaded already
        if (fetchingWeatherStatus !== 'Loaded' || fetchingWeatherStatus !== 'Loading') 
          getTodaysWeather(organizationsList[0].latitude,organizationsList[0].longitude,organizationsList[0].timezone);
      }
    } else {
      if (fetchingOrganizationsStatus !== 'Loading') {
        getOrganizations();
      }
    }
  };

  componentDidUpdate(prevProps) {
    const { organizationsList, getTodaysWeather } = this.props;

    //If the Organization has been updated, set location and retrieve Today's weather at its location
    if (organizationsList !== prevProps.organizationsList) {
      //Use the first Organization returned as the application currently supports only a single Organization
      if (organizationsList.length > 0) {
        this.setState({ location: (organizationsList[0].city+', '+organizationsList[0].region) });
        getTodaysWeather(organizationsList[0].latitude,organizationsList[0].longitude,organizationsList[0].timezone);
      }
    }
  }

  render() {
    const { location } = this.state;
    const { fetchingOrganizationsStatus, fetchingWeatherStatus } = this.props;
    const { current, morning, afternoon, night } = this.props.todaysWeather;
    const { classes } = this.props;
   
    if (fetchingOrganizationsStatus === 'Loaded' && fetchingWeatherStatus === 'Loaded') {
      return (
        <Card className={classes.card}>
          <CardContent className={classes.cardContent} align="left">
            <Typography align="center" variant="h6" noWrap={true}>
              {location}
            </Typography>
            <Grid container spacing={8} alignItems="center">
              <Grid item xs={6}>
                <Typography align="right" variant="h4">
                  {current.temperature.toFixed(0)}&deg;
                </Typography>
              </Grid>
              <Grid item xs={6} style={{padding: 0}}>
                <Tooltip title={<Typography color="inherit" variant="body2">{current.forecast}</Typography>}>
                  <img src={getWeatherIcon(current.icon)} height="48" width="auto" alt="current" />
                </Tooltip>
              </Grid>
            </Grid>

            <Typography align="center" variant="subtitle2" noWrap>
              {current.summary}
            </Typography>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 6,
                paddingLeft: 8,
                paddingRight: 8,
              }}
            >
              {/* Sunrise */}
              <div style={{ textAlign: 'left' }}>
                <Typography variant="caption" color="textSecondary">
                  Sunrise
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span role="img" aria-label="sunrise" style={{ marginRight: 4 }}>🌅</span>
                  <Typography variant="body2" color="textSecondary">
                    {current.sunrise}
                  </Typography>
                </div>
              </div>

              {/* Sunset */}
              <div style={{ textAlign: 'left' }}>
                <Typography variant="caption" color="textSecondary">
                  Sunset
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span role="img" aria-label="sunset" style={{ marginRight: 4 }}>🌇</span>
                  <Typography variant="body2" color="textSecondary">
                    {current.sunset}
                  </Typography>
                </div>
              </div>
            </div>


          </CardContent>
          <Divider/>
          <CardContent className={classes.cardContent} align="left">
            <Grid container spacing={8}>
              <Grid item xs={4}>
                <Typography align="center" color="textSecondary" variant="subtitle2">
                  Morning
                </Typography>
                <Grid container spacing={8} alignItems="center" style={{height: 48}}>
                  <Grid item xs={6} align="right">
                    <Typography align="right" variant="h5">
                      {morning.temperature.toFixed(0)}&deg;
                    </Typography>
                  </Grid>
                  <Grid item xs={6} style={{padding: 0}}>
                    <Tooltip title={<Typography color="inherit" variant="body2">{morning.summary}</Typography>}>
                      <img src={getWeatherIcon(morning.icon)} height="32" width="auto" alt="current" />
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="center" style={{height: 32}}>
                  <Grid item xs={4} align="right">
                    <img src={windIcon} height="20" width="auto" alt="current" />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography align="center" variant="subtitle2">
                      {morning.windSpeed.toFixed(0)} mph
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="center" style={{height: 32}}>
                  <Grid item xs={4} align="right">
                    <img src={rainIcon} height="20" width="auto" alt="current" />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography align="center" variant="body1">
                      {(morning.precipProbability*100).toFixed(0)}%
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Typography align="center" color="textSecondary" variant="subtitle2">
                  Afternoon
                </Typography>
                <Grid container spacing={8} alignItems="center" style={{height: 48}}>
                  <Grid item xs={6}>
                    <Typography align="right" variant="h5">
                      {afternoon.temperature.toFixed(0)}&deg;
                    </Typography>
                  </Grid>
                  <Grid item xs={6} style={{padding: 0}}>
                    <Tooltip title={<Typography color="inherit" variant="body2">{afternoon.summary}</Typography>}>
                      <img src={getWeatherIcon(afternoon.icon)} height="32" width="auto" alt="current" />
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="center" style={{height: 32}}>
                  <Grid item xs={4} align="right">
                    <img src={windIcon} height="20" width="auto" alt="current" />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography align="center" variant="subtitle2">
                      {afternoon.windSpeed.toFixed(0)} mph
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="center" style={{height: 32}}>
                  <Grid item xs={4} align="right">
                    <img src={rainIcon} height="20" width="auto" alt="current" />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography align="center" variant="body1">
                      {(afternoon.precipProbability*100).toFixed(0)}%
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Typography align="center" color="textSecondary" variant="subtitle2">
                  Night
                </Typography>
                <Grid container spacing={8} alignItems="center" style={{height: 48}}>
                  <Grid item xs={6}>
                    <Typography align="right" variant="h5">
                      {night.temperature.toFixed(0)}&deg;
                    </Typography>
                  </Grid>
                  <Grid item xs={6} style={{padding: 0}}>
                    <Tooltip title={<Typography color="inherit" variant="body2">{night.summary}</Typography>}>
                      <img src={getWeatherIcon(night.icon)} height="32" width="auto" alt="current" />
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="center" style={{height: 32}}>
                  <Grid item xs={4} align="right">
                    <img src={windIcon} height="20" width="auto" alt="current" />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography align="center" variant="subtitle2">
                      {night.windSpeed.toFixed(0)} mph
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={8} alignItems="center" style={{height: 32}}>
                  <Grid item xs={4} align="right">
                    <img src={rainIcon} height="20" width="auto" alt="current" />
                  </Grid>
                  <Grid item xs={8}>
                    <Typography align="center" variant="body1">
                      {(night.precipProbability*100).toFixed(0)}%
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      );
    } else {
      return (
        <Card className={classes.card}>
          <CardHeader
            align="left"
            title={
              <Typography variant="h6">
                {location} Weather loading...
              </Typography>
            }
          />
        </Card>
      );
    }
  }
}

WeatherWidget.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WeatherWidget);



// WEBPACK FOOTER //
// ./src/components/WeatherWidget.js